var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"empty-holder"},[_c('img',{attrs:{"src":require("../assets/icons/empty-state.svg"),"alt":"No recodes"}}),_c('h5',[_vm._v(_vm._s(_vm.emptyData.header))]),_c('h6',[_vm._v(_vm._s(_vm.emptyData.option))])])])}
var staticRenderFns = []

export { render, staticRenderFns }